import noop from 'lodash/noop';
import PropTypes from 'prop-types';
import React from 'react';

import { Flex } from '../grid';
import { Icon } from '../icons';
import { Link } from '../link';
import { P } from '../typography';

const PageReturnLink = ({ navigationLink, linkText, onClick }) => (
  <Link href={navigationLink} onClick={onClick}>
    <Flex alignItems="center" mb={1}>
      <Icon name="chevron" fill="greyPrimary" height="1.5rem" width="1.5rem" rotate="90deg" />
      <P variant={3} color="greyPrimary">
        {linkText}
      </P>
    </Flex>
  </Link>
);

PageReturnLink.propTypes = {
  linkText: PropTypes.string.isRequired,
  navigationLink: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

PageReturnLink.defaultProps = {
  onClick: noop,
};

export { PageReturnLink };
